const ITEM_HEIGHT = 42;
const TOP_INDENT_COEFFICIENT = 30;
const BOTTOM_INDENT_COEFFICIENT = 20;
export function getDirectionDropDownShow({ maxItemsVisible, ref, }) {
    const windowOuterHeight = window.outerHeight;
    const offsetOptions = ref?.current?.getBoundingClientRect();
    const isTopDirectionFirst = (offsetOptions?.top || 0) < ITEM_HEIGHT * maxItemsVisible + TOP_INDENT_COEFFICIENT;
    const isTopDirectionSecond = windowOuterHeight - (offsetOptions?.bottom || 0) <
        ITEM_HEIGHT * maxItemsVisible + BOTTOM_INDENT_COEFFICIENT;
    return {
        isTopDirectionFirst,
        isTopDirectionSecond,
    };
}
